<template>
  <div>
    <a-result status="403" :title="$t('err.noUser')"
              sub-title="Sorry, you are not authorized to access this page.">
      <template #extra>
        <a-button type="primary" @click="goHome">
          Back Home
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  name: "noUser",
  methods : {
    goHome : function (){
      this.$router.push("/home");
    }
  }
}
</script>

<style scoped>

</style>